export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/logo-mark.png"
    alt=""
    aria-hidden="true"
    data-testid="logo-mark"
    className={`object-contain ${className}`}
  />
);

export const LogoFull = ({ compact = false }) => (
  <span
    data-testid="logo-full"
    className={`inline-flex items-center rounded-md bg-white shadow-md ${
      compact ? "px-2 py-1" : "px-3 py-1.5"
    }`}
  >
    <img
      src="/logo.jpg"
      alt="Family Auto Sales — Committed to your satisfaction"
      className={compact ? "h-8 w-auto" : "h-11 w-auto"}
    />
  </span>
);
